import { http } from 'services/BaseApi';
import { IBanners } from 'interfaces/Banners/IBanners';

export const getBannersSvc = async (userId: string): Promise<IBanners[]> => {
  return await http.get<IBanners[]>(`/banners/${userId}`);
};
